import { Badge, useTheme } from "@mui/material";
import { Users } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { HeaderIconButton } from "web_myplann/Shared/Header/HeaderIconButton";

const R = Resources.Advisor;

type Props = {
	pendingCount: number;
	onClick: () => void;
};

export const AdvisorPickerButton: FC<Props> = ({ pendingCount, onClick }) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<Badge
			badgeContent={pendingCount}
			color="error"
			max={99}
			invisible={pendingCount === 0}
		>
			<HeaderIconButton
				aria-label={t(R.pickerAria, { count: pendingCount })}
				onClick={onClick}
			>
				<Users size={theme.iconSize.md} color={theme.palette.grey[700]} />
			</HeaderIconButton>
		</Badge>
	);
};
